<template>
  <div>
    <label class="d-block">
      {{ $t(config.label) }}
    </label>
    <validation-provider
      :name="$t(config.name)"
      :rules="config.rules"
      v-slot="{ errors }"
    >
      <v-select
        v-model="model"
        :options="profiles"
        :clearable="false"
        :multiple="multiple || multiple === 1"
        :reduce="(profile) => profile.value"
        input-id="notification_command_profiles"
        @input="$emit('input', model)"
      />
      <p v-if="config.hint" class="mb-0 small">{{ $t(config.hint) }}</p>
      <p v-if="errors" class="small text-danger">{{ errors[0] }}</p>
    </validation-provider>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { ValidationProvider } from "vee-validate";
import store from "@/store";

const RECEIVE_NOTIFICATION_PERMISSION =
  "allow_to_receive_notifications_from_cmd_notification";

export default {
  components: {
    vSelect,
    ValidationProvider,
  },
  props: {
    value: Array | Object,
    multiple: Boolean | Number,
    config: Object,
  },
  data() {
    return {
      model: null,
    };
  },
  computed: {
    profiles() {
      return store.getters["profile/getItems"]
        .filter((profile) => profile.permissions?.some(
          (permission) => permission.action === RECEIVE_NOTIFICATION_PERMISSION
        ))
        .map((profile) => ({
          value: profile.id,
          label: profile.type,
        }));
    },
  },
  created() {
    this.model = this.value;
  },
  mounted() {
    store.dispatch("profile/getAll", { max: 1000 });
  },
};
</script>
